let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("HFjG2")).then(() => parcelRequire('47XFm'));